export enum UserAccess {
    Access = "Authorisation.User Access.Access",
    Update = "Authorisation.User Access.Update",
}